<div style="position: relative;">

  <div class="dialog-title-row">
  <h1 mat-dialog-title class="dialog-wide">Invoice for {{ getInvoiceDialogTitle() }}</h1>
  <div class="timesheet-type-badge" *ngIf="project?.timesheetRequired && project?.timesheetType">
    {{ project?.timesheetType?.toString()?.toUpperCase() }}
  </div>
  <div class="project-type-badge" *ngIf="project?.projectType">
    {{ project?.projectType?.toString()?.toUpperCase() }}
  </div>
  </div>
<div *ngIf="isLoadingAll()" style="position: absolute; left: 0; top: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.85); z-index: 2000; display:flex; align-items:center; justify-content:center;">
  <div style="text-align:center;">
    <div class="loader" style="border:6px solid #f3f3f3; border-top:6px solid #3498db; border-radius:50%; width:48px; height:48px; animation: spin 1s linear infinite; margin:0 auto 8px;"></div>
    <div style="font-weight:600; color:#333;">Loading…</div>
  </div>
</div>

<style>
@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
</style>
<div *ngIf="!isLoaded">
  <p>Loading data ...</p>
</div>
<div mat-dialog-content *ngIf="isLoaded && timesheets.length > 0">
  <!-- Timesheet requirement notices -->
  <div class="alert alert-warning" style="margin-bottom:12px;"
       *ngIf="project?.timesheetRequired && !project?.timesheetType">
    Tijdregistratie is verplicht voor dit project. Selecteer het juiste type (bv. Tempo, interne of klant) in de projectdetails voordat je factureert.
  </div>
  <div class="alert alert-success" style="margin-bottom:12px;"
       *ngIf="project?.timesheetRequired && project?.timesheetType">
    Tijdregistratie is verplicht. Geselecteerd type: <strong>{{ project?.timesheetType }}</strong>.
  </div>
  <div class="alert alert-info" style="margin-bottom:12px;"
       *ngIf="!project?.timesheetRequired">
    Tijdregistratie is niet verplicht voor dit project (informatief).
  </div>
  <div class="inputLine" style="margin-bottom: 16px; font-size: 14px;">
    <span style="display: block; font-weight: 500; margin-bottom: 6px;">Customer:</span>
    <input 
      type="text" 
      list="suppliersList"
      [(ngModel)]="supplierSearchText"
      (ngModelChange)="updateCreateDisabled()"
      (change)="onSupplierSelected($event)"
      placeholder="Type to search suppliers..." 
      style="padding: 10px; font-size: 14px; border: 1px solid #ccc; border-radius: 4px; width: 100%; max-width: 400px; box-sizing: border-box;">
    <datalist id="suppliersList">
      <option *ngFor="let c of comanageSuppliers" [value]="c.name" [attr.data-number]="c.number">
    </datalist>
  </div>
  <!-- Mode Tabs -->
  <div style="margin-top: 8px; margin-bottom: 8px;">
    <div style="display:inline-flex; gap:8px; border-bottom: 1px solid #ddd; padding-bottom: 8px;">
      <button type="button" (click)="setInvoiceMode('time')"
              [style.fontWeight]="invoiceMode==='time' ? '600' : '500'"
              [style.borderBottom]="invoiceMode==='time' ? '2px solid #2196F3' : '2px solid transparent'"
              style="background: none; border: none; padding: 6px 10px; cursor: pointer;">
        By Time
      </button>
      <button type="button" (click)="setInvoiceMode('account')"
              [style.fontWeight]="invoiceMode==='account' ? '600' : '500'"
              [style.borderBottom]="invoiceMode==='account' ? '2px solid #2196F3' : '2px solid transparent'"
              style="background: none; border: none; padding: 6px 10px; cursor: pointer;">
        By Account
      </button>
      <button type="button" (click)="setInvoiceMode('ses')"
              [style.fontWeight]="invoiceMode==='ses' ? '600' : '500'"
              [style.borderBottom]="invoiceMode==='ses' ? '2px solid #2196F3' : '2px solid transparent'"
              style="background: none; border: none; padding: 6px 10px; cursor: pointer;">
        By SES
      </button>
    </div>
  </div>

  <div *ngIf="invoiceMode==='ses'" class="ses-selector" style="margin: 12px 0 16px 0; padding: 12px; border: 1px solid #d6e4ff; border-radius: 4px; background: #f8fbff;">
    <label style="display:block; font-weight: 700; margin-bottom: 6px;">SES-document:<span style="color:red;"> *</span></label>
    <select
      [(ngModel)]="selectedSesFileId"
      (ngModelChange)="onSesDocumentSelected($event)"
      [style.border-color]="!selectedSesDoc ? 'red' : '#ccc'"
      style="padding: 8px; font-size: 14px; border: 1px solid; border-radius: 4px; width: 100%; box-sizing: border-box; background: white;">
      <option value="" disabled>-- Kies een SES-document --</option>
      <option *ngFor="let doc of sesDocuments" [value]="doc.value">{{ doc.label }}</option>
      <option [value]="addNewSesDocumentValue">+ Add new SES document...</option>
    </select>
    <div *ngIf="sesDocuments.length === 0" style="color:#d32f2f; margin-top: 4px;">
      Geen SES-document gevonden in de Files tab. Kies “+ Add new SES document...” om er een toe te voegen aan dit project.
    </div>
    <div *ngIf="selectedSesDoc" style="display: flex; flex-wrap: wrap; gap: 8px; margin-top: 8px; font-size: 12px;">
      <span style="font-weight:700; color:#1b3a57;"><i class="las la-file-alt"></i> SES nr: {{ getSelectedSesReferenceLabel() }}</span>
      <span *ngIf="selectedSesDoc.extractedFileNumber" style="color: #555;"><i class="las la-hashtag"></i> File nr: {{ selectedSesDoc.extractedFileNumber }}</span>
      <span *ngIf="selectedSesDoc.extractedPoNumber" style="color: #555;"><i class="las la-link"></i> PO: {{ selectedSesDoc.extractedPoNumber }}</span>
      <span *ngIf="selectedSesDoc.extractedPeriodFrom || selectedSesDoc.extractedPeriodTo" style="color: #555;">
        <i class="las la-calendar"></i> Periode: {{ selectedSesDoc.extractedPeriodFrom || '?' }} — {{ selectedSesDoc.extractedPeriodTo || '?' }}
      </span>
    </div>
  </div>

  <p class="inputLine" style="margin-bottom: 16px; font-size: 14px;">
    <span style="display: block; font-weight: 500; margin-bottom: 6px;">Date:</span>
    <input class="mediumLength" type="date" [(ngModel)]="invoiceDate" style="padding: 10px; font-size: 14px; border: 1px solid #ccc; border-radius: 4px; width: 100%; max-width: 300px;">
  </p>
  <p class="inputLine" style="margin-bottom: 16px; font-size: 14px;">
    <span style="display: block; font-weight: 500; margin-bottom: 6px;">Subject:</span>
    <input class="mediumLength" type="text" [(ngModel)]="subjectWithDate" style="padding: 10px; font-size: 14px; border: 1px solid #ccc; border-radius: 4px; width: 100%; max-width: 400px;">
  </p>
  <div class="inputLine" style="margin-bottom: 16px; font-size: 14px;">
    <div style="display:flex; flex-direction: column; gap:8px; max-width: 600px;">
        <div style="display:flex; gap:12px; align-items:flex-end; flex-wrap: wrap;">
          <div style="flex:1; min-width: 240px; display:flex; flex-direction: column; gap:6px;">
            <label style="font-weight: 500;"><strong>Departement:</strong></label>
              <input [value]="(project?.projectType || '')?.toString()?.toUpperCase()" type="text" readonly placeholder="No department"
              style="padding: 8px; font-size: 14px; border: 1px solid #ccc; border-radius: 4px; width: 100%; box-sizing: border-box; background-color: #f7f7f7; color: #333;" />
          </div>
          <div style="flex:1; min-width: 240px; display:flex; flex-direction: column; gap:6px;">
            <label style="font-weight: 500;"><strong>Our reference (Jira key):</strong></label>
            <ng-container *ngIf="jiraRawKey && jiraRawKey.length > 0; else jiraKeySelect">
                <input 
                  type="text"
                  list="jiraProjectKeysList"
                  [ngModel]="jiraRawKey"
                  (ngModelChange)="jiraRawKey = $event"
                  (change)="onJiraKeySelected($event)"
                  placeholder="Selecteer Jira key (type om te zoeken)"
                  style="padding: 8px; font-size: 14px; border: 1px solid #ccc; border-radius: 4px; width: 100%; box-sizing: border-box;" />
                <datalist id="jiraProjectKeysList">
                  <option *ngFor="let c of jiraProjectKeyList$" [value]="c.jiraKey" [attr.label]="c.projectName + ' [' + c.jiraKey + ']'">
                </datalist>
            </ng-container>
            <ng-template #jiraKeySelect>
              <div *ngIf="!jiraProjectKeysLoaded" style="font-size: 12px; color: #666;">Loading Jira project keys...</div>
              <div *ngIf="jiraProjectKeysLoaded">
                <input 
                  type="text" 
                  list="jiraProjectKeysList"
                  (change)="onJiraKeySelected($event)"
                  placeholder="Choose Jira project key"
                  style="padding: 8px; font-size: 14px; border: 1px solid #ccc; border-radius: 4px; width: 100%; box-sizing: border-box;" />
                <datalist id="jiraProjectKeysList">
                  <option value="" disabled>Choose the corresponding Jira Project Key</option>
                  <option *ngFor="let credential of jiraProjectKeyList$" [value]="credential.jiraKey"
                          [attr.label]="credential.projectName + ' - ' + credential.jiraKey"></option>
                </datalist>
              </div>
            </ng-template>
          </div>
            <div *ngIf="project?.poRequired" style="flex:1; min-width: 240px; display:flex; flex-direction: column; gap:6px;">
            <label style="font-weight: 500;"><strong>PO-nummer:</strong><span style="color:red;"> *</span></label>
            <select *ngIf="poDocuments.length > 0" [(ngModel)]="selectedPoFileId" (change)="onPoDocumentSelected(selectedPoFileId)"
              [style.border-color]="!poNumber?.trim() ? 'red' : '#ccc'"
              style="padding: 8px; font-size: 14px; border: 1px solid; border-radius: 4px; width: 100%; box-sizing: border-box; background: white;">
              <option value="" disabled>-- Kies een PO --</option>
              <option *ngFor="let doc of poDocuments" [value]="doc.value">{{ doc.label }}</option>
            </select>
            <input *ngIf="poDocuments.length === 0" [(ngModel)]="poNumber" (blur)="onPoNumberBlur()" (input)="onPoNumberInput($event.target.value)" type="text"
              placeholder="PO-nummer (verplicht)"
              [style.border-color]="!poNumber?.trim() ? 'red' : '#ccc'"
              style="padding: 8px; font-size: 14px; border: 1px solid; border-radius: 4px; width: 100%; box-sizing: border-box;" />
            <small *ngIf="!poNumber?.trim()" style="color: red;">PO-nummer is verplicht voor dit project.</small>
            <!-- PO verification badges -->
            <div *ngIf="selectedPoDoc" style="display: flex; flex-wrap: wrap; gap: 6px; margin-top: 2px; font-size: 12px;">
              <span *ngIf="selectedPoDoc.extractedAmount != null"
                [style.color]="isAmountWithinBudget(selectedPoDoc) === true ? '#2e7d32' : '#c62828'"
                [title]="'PO bedrag: ' + (selectedPoDoc.extractedCurrency || 'EUR') + ' ' + selectedPoDoc.extractedAmount">
                <i class="las" [class.la-check-circle]="isAmountWithinBudget(selectedPoDoc) === true" [class.la-exclamation-triangle]="isAmountWithinBudget(selectedPoDoc) === false"></i>
                Bedrag: {{ selectedPoDoc.extractedCurrency || 'EUR' }} {{ selectedPoDoc.extractedAmount | number:'1.2-2' }}
              </span>
              <span *ngIf="selectedPoDoc.extractedPeriodFrom || selectedPoDoc.extractedPeriodTo"
                [style.color]="isInvoiceDateInPeriod(selectedPoDoc) === true ? '#2e7d32' : isInvoiceDateInPeriod(selectedPoDoc) === false ? '#c62828' : '#555'"
                [title]="'PO periode: ' + (selectedPoDoc.extractedPeriodFrom || '?') + ' t/m ' + (selectedPoDoc.extractedPeriodTo || '?')">
                <i class="las" [class.la-check-circle]="isInvoiceDateInPeriod(selectedPoDoc) === true" [class.la-exclamation-triangle]="isInvoiceDateInPeriod(selectedPoDoc) === false"></i>
                Periode: {{ selectedPoDoc.extractedPeriodFrom || '?' }} — {{ selectedPoDoc.extractedPeriodTo || '?' }}
              </span>
            </div>
          </div>
        </div>

      <div *ngIf="project?.sesRequired && invoiceMode !== 'ses'" style="margin-bottom: 8px;">
        <label style="font-weight: 500;"><strong>SES-nummer:</strong><span style="color:red;"> *</span></label>
        <select *ngIf="sesDocuments.length > 0" [(ngModel)]="selectedSesFileId" (ngModelChange)="onSesDocumentSelected($event)"
          [style.border-color]="(!hasSesReference() && !selectedSesDoc) ? 'red' : '#ccc'"
          style="padding: 8px; font-size: 14px; border: 1px solid; border-radius: 4px; width: 100%; box-sizing: border-box; background: white;">
          <option value="" disabled>-- Kies een SES --</option>
          <option *ngFor="let doc of sesDocuments" [value]="doc.value">{{ doc.label }}</option>
          <option [value]="addNewSesDocumentValue">+ Add new SES document...</option>
        </select>
        <input *ngIf="sesDocuments.length === 0" [(ngModel)]="sesNumber" (blur)="onSesNumberBlur()" (input)="onSesNumberInput($event.target.value)" type="text"
          placeholder="SES-nummer (verplicht)"
          [style.border-color]="(!hasSesReference() && !selectedSesDoc) ? 'red' : '#ccc'"
          style="padding: 8px; font-size: 14px; border: 1px solid; border-radius: 4px; width: 100%; box-sizing: border-box;" />
        <button *ngIf="sesDocuments.length === 0" type="button" (click)="openAddSesDocumentModal()"
          style="margin-top:6px; background:none; border:none; padding:0; color:#1a73e8; font-weight:600; cursor:pointer;">
          + Add new SES document...
        </button>
        <small *ngIf="!hasSesReference() && !selectedSesDoc" style="color: red;">SES-nummer of SES-document is verplicht voor dit project.</small>
        <!-- SES verification badges -->
        <div *ngIf="selectedSesDoc" style="display: flex; flex-wrap: wrap; gap: 6px; margin-top: 4px; font-size: 12px;">
          <span *ngIf="selectedSesDoc.extractedAmount != null"
            [style.color]="isAmountWithinBudget(selectedSesDoc) === true ? '#2e7d32' : '#c62828'"
            [title]="'SES bedrag: ' + (selectedSesDoc.extractedCurrency || 'EUR') + ' ' + selectedSesDoc.extractedAmount">
            <i class="las" [class.la-check-circle]="isAmountWithinBudget(selectedSesDoc) === true" [class.la-exclamation-triangle]="isAmountWithinBudget(selectedSesDoc) === false"></i>
            Bedrag: {{ selectedSesDoc.extractedCurrency || 'EUR' }} {{ selectedSesDoc.extractedAmount | number:'1.2-2' }}
            <span *ngIf="isAmountWithinBudget(selectedSesDoc) === true" style="color: #2e7d32;"> ✓ OK</span>
            <span *ngIf="isAmountWithinBudget(selectedSesDoc) === false" style="color: #c62828;"> ⚠ Factuurbedrag overschrijdt SES</span>
          </span>
          <span *ngIf="selectedSesDoc.extractedPeriodFrom || selectedSesDoc.extractedPeriodTo"
            [style.color]="isInvoiceDateInPeriod(selectedSesDoc) === true ? '#2e7d32' : isInvoiceDateInPeriod(selectedSesDoc) === false ? '#c62828' : '#555'"
            [title]="'SES periode: ' + (selectedSesDoc.extractedPeriodFrom || '?') + ' t/m ' + (selectedSesDoc.extractedPeriodTo || '?')">
            <i class="las" [class.la-check-circle]="isInvoiceDateInPeriod(selectedSesDoc) === true" [class.la-exclamation-triangle]="isInvoiceDateInPeriod(selectedSesDoc) === false"></i>
            Periode: {{ selectedSesDoc.extractedPeriodFrom || '?' }} — {{ selectedSesDoc.extractedPeriodTo || '?' }}
            <span *ngIf="isInvoiceDateInPeriod(selectedSesDoc) === true" style="color: #2e7d32;"> ✓ OK</span>
            <span *ngIf="isInvoiceDateInPeriod(selectedSesDoc) === false" style="color: #c62828;"> ⚠ Factuurdatum buiten SES-periode</span>
          </span>
          <span *ngIf="selectedSesDoc.extractedPoNumber" style="color: #555;">
            <i class="las la-link"></i> PO: {{ selectedSesDoc.extractedPoNumber }}
          </span>
        </div>
      </div>

      <label style="font-weight: 500;">Vrije tekst:</label>
      <textarea [(ngModel)]="comanageInvoiceText" (blur)="onComanageInvoiceTextBlur()" rows="3" placeholder="Vrije tekst gelinkt aan dit project (optioneel)"
        style="padding: 10px; font-size: 14px; border: 1px solid #ccc; border-radius: 4px; width: 100%; box-sizing: border-box;"></textarea>
    </div>
  </div>
  <!-- By Account: group selector and lines vertically to fix layout -->
  <div *ngIf="invoiceMode==='account'" style="margin-top: 12px; font-size: 14px;">
        <div class="alert alert-danger" style="margin-top: 8px; margin-bottom: 8px;"
          *ngIf="project?.timesheetRequired && !hasSelectedAccountLine()">
      Tijdregistratie is verplicht. Selecteer minstens één accountregel om te kunnen factureren.
    </div>
    <div class="account-selector" style="margin-bottom: 12px;">
      <div class="account-selector__title">Tempo accounts</div>
      <div *ngIf="tempoAccounts.length === 0" class="account-selector__empty">Geen Tempo accounts gevonden voor dit project.</div>
      <div *ngIf="tempoAccounts.length > 0" class="account-selector__list">
        <label *ngFor="let a of tempoAccounts" class="account-selector__item">
          <input
            type="checkbox"
            [checked]="isTempoAccountSelected(a.id)"
            (change)="onTempoAccountToggled(a.id, $event.target.checked)">
          <span class="account-selector__key">{{ a.key || a.id }}</span>
          <span class="account-selector__name">{{ a.name || '-' }}</span>
          <span class="account-selector__meta" *ngIf="accountWorklogDurationLabelById[a.id]">{{ accountWorklogDurationLabelById[a.id] }}</span>
        </label>
      </div>
    </div>

    <div class="period-section">
      <span class="period-label">Periode:</span>
      <div class="period-range">
        <input class="period-date-input" type="date" [(ngModel)]="worklogsFrom" (change)="onWorklogDateRangeChanged()">
        <input class="period-date-input" type="date" [(ngModel)]="worklogsTo" (change)="onWorklogDateRangeChanged()">
        <div class="extra-months-inline">
          <span class="extra-months-inline-label">extra:</span>
          <label>voor
            <input
              class="extra-months-inline-input"
              type="number"
              min="0"
              max="12"
              [(ngModel)]="additionalMonthsBefore"
              (change)="onAdditionalMonthsChanged()"
            >
          </label>
          <label>na
            <input
              class="extra-months-inline-input"
              type="number"
              min="0"
              max="12"
              [(ngModel)]="additionalMonthsAfter"
              (change)="onAdditionalMonthsChanged()"
            >
          </label>
          <span class="extra-months-inline-hint">(standaard 0)</span>
        </div>
      </div>
    </div>

    

    <p class="invoiceLines" style="margin-top: 4px; margin-bottom: 12px; font-weight: 600; font-size: 14px;">Invoice lines (By Account):</p>
    <div class="alert alert-info" style="margin-top: -6px; margin-bottom: 10px;" *ngIf="project?.invoiceByDay">
      Gefactureerd per dag i.p.v. per uur ({{ getProjectHoursPerDay() | number: '1.0-2' }}u/dag).
    </div>
    <div *ngIf="accountIssueLines.length === 0" style="color:#777; font-size: 13px;">Geen worklogs gevonden binnen de geselecteerde periode.</div>
    <div *ngFor="let line of accountIssueLines; trackBy: trackByIssueLine">
      <p class="indent invoiceLine" [style.opacity]="line.selected ? 1 : 0.6" style="display: flex; align-items: center; gap: 12px; margin: 12px 0; padding: 12px; border: 1px solid #e0e0e0; border-radius: 4px; background-color: #fafafa;">
        <input type="checkbox" [checked]="line.selected" (change)="onAccountLineSelectionChanged(line, $event.target.checked)" style="width: 18px; height: 18px; cursor: pointer;">
         <span style="min-width: 140px; font-size: 12px; color: #444; font-weight: 600;">{{ line.accountKey || line.accountLabel || line.accountId }}</span>
         <input type="text"
           [ngModel]="line._editedDescription ?? (line.jiraKey ? (line.jiraKey + (line.summary ? ' - ' + line.summary : '')) : ('Issue ' + line.issueId))"
           (ngModelChange)="line._editedDescription = $event"
           [disabled]="!line.selected"
           style="min-width: 320px; padding: 6px; font-size: 13px; border: 1px solid #ccc; border-radius: 3px; font-weight: 500;">
         <input class="smallLength" type="number" [ngModel]="line.totalHours | number: '1.2-2'"
           (ngModelChange)="onAccountHoursChanged(line, $event)"
           [disabled]="!line.selected"
           step="0.01"
           style="width: 80px; padding: 8px; font-size: 13px; border: 1px solid #ccc; border-radius: 3px;">
        <span style="font-weight: 500;">×</span>
        <input class="smallLength" type="number" [ngModel]="line.effectiveRate" (ngModelChange)="onAccountRateInputChanged(line, $event)" (blur)="onAccountRateBlur(line)"
           [disabled]="!line.selected"
           step="0.01"
           style="width: 100px; padding: 8px; font-size: 13px; border: 1px solid #ccc; border-radius: 3px;">
        <span style="font-weight: 500;">=</span>
        <span style="min-width: 140px; font-weight: 600;">€ {{ (line.effectiveRate != null ? (line.totalHours * line.effectiveRate) : null) | number: '1.2-2' }}</span>
      </p>
      <div class="indent" *ngIf="project?.invoiceByDay && line.selected" style="margin-top: -8px; margin-bottom: 8px; color: #555; font-size: 12px;">
        {{ line.totalHours | number: '1.2-2' }} dagen gefactureerd aan € {{ line.effectiveRate | number: '1.2-2' }} / dag
      </div>
    </div>
    <div *ngIf="missingAccountPriceMessages.length > 0" style="margin-top:8px; color:#d32f2f; font-weight:600;">
      <div *ngFor="let msg of missingAccountPriceMessages">{{ msg }}</div>
    </div>
    <!-- Projectmanagement percentage invoer -->
    <div style="margin-top: 16px; display: flex; align-items: center; gap: 12px;">
      <input type="checkbox" [(ngModel)]="addProjectManagementFee" style="width: 18px; height: 18px; cursor: pointer;">
      <span style="min-width: 150px; font-weight: 500;">projectmanagement - </span>
      <input type="number" [(ngModel)]="projectManagementPercentage" min="0" max="100" style="width: 60px; padding: 4px; font-size: 14px; border: 1px solid #ccc; border-radius: 4px;">%
      <span style="width: 70px; text-align: center; font-weight: 500;">1</span>
      <span style="font-weight: 500;">×</span>
      <span style="width: 80px; text-align: right; font-weight: 500;">€{{ calculateProjectManagementFeeBeforeVat() | number: '1.2-2' }}</span>
      <span style="font-weight: 500;">=</span>
      <span style="font-weight: bold; min-width: 100px; text-align: right;">€{{ calculateProjectManagementFeeWithVat() | number: '1.2-2' }}</span>
    </div>
    <!-- Totaalregel -->
    <div style="margin-top: 16px; display: flex; align-items: center; gap: 12px; background: #f7f7f7; border-radius: 4px; padding: 12px; font-weight: bold;">
      <span style="min-width: 150px;">Totaal</span>
      <span style="font-weight: bold; min-width: 100px; text-align: right;">€{{ calculateAccountTotalWithPM() | number: '1.2-2' }}</span>
    </div>
  </div>

  <div *ngIf="invoiceMode==='ses'" style="margin-top: 12px; font-size: 14px;">
    <div class="alert alert-info" style="margin-bottom: 10px;">
      Facturatie gebeurt op basis van het geselecteerde SES-document. Het SES-bedrag wordt gebruikt als factuurbedrag; de gelogde uren worden gecontroleerd tegen de SES-uren wanneer die uit het document konden worden gelezen.
    </div>
    <div class="alert alert-danger" style="margin-bottom: 10px;" *ngIf="!selectedSesDoc">
      Selecteer een SES-document om een factuur op te stellen.
    </div>
    <div class="alert alert-danger" style="margin-bottom: 10px;" *ngIf="selectedSesDoc && getSelectedSesAmount() <= 0">
      Het geselecteerde SES-document heeft geen totaalbedrag. Extracteer of corrigeer eerst het SES-document.
    </div>
    <div class="alert alert-danger" style="margin-bottom: 10px;" *ngIf="isSelectedSesHoursMatch() === false">
      Gelogde uren ({{ getSelectedSesLoggedHours() | number:'1.2-2' }}u) komen niet overeen met SES-uren ({{ getSelectedSesApprovedHours() | number:'1.2-2' }}u).
    </div>
    <div class="alert alert-success" style="margin-bottom: 10px;" *ngIf="isSelectedSesHoursMatch() === true">
      Geselecteerde gelogde uren komen overeen met het SES-document.
    </div>
    <div class="ses-summary" style="display:grid; grid-template-columns: repeat(4, minmax(120px, 1fr)); gap: 10px; margin-bottom: 12px;">
      <div style="border:1px solid #ddd; padding:10px; border-radius:4px;">
        <div style="font-size:11px; color:#666; text-transform:uppercase;">SES amount</div>
        <div style="font-weight:700;">€{{ getSelectedSesAmount() | number:'1.2-2' }}</div>
      </div>
      <div style="border:1px solid #ddd; padding:10px; border-radius:4px;">
        <div style="font-size:11px; color:#666; text-transform:uppercase;">SES hours</div>
        <div style="font-weight:700;">{{ getSelectedSesApprovedHours() === null ? '—' : (getSelectedSesApprovedHours() | number:'1.2-2') + 'u' }}</div>
      </div>
      <div style="border:1px solid #ddd; padding:10px; border-radius:4px;">
        <div style="font-size:11px; color:#666; text-transform:uppercase;">Logged hours</div>
        <div style="font-weight:700;">{{ getSelectedSesLoggedHours() | number:'1.2-2' }}u</div>
      </div>
      <div style="border:1px solid #ddd; padding:10px; border-radius:4px;">
        <div style="font-size:11px; color:#666; text-transform:uppercase;">Rate</div>
        <div style="font-weight:700;">{{ getSelectedSesUnitRate() === null ? '—' : '€' + (getSelectedSesUnitRate() | number:'1.2-2') }}</div>
      </div>
    </div>
    <p class="invoiceLines" style="margin-top: 8px; margin-bottom: 8px; font-weight: 600; font-size: 14px;">Timeslots linked to selected SES period:</p>
    <div *ngFor="let timeslot of selectedTimeslots" style="display:flex; gap:10px; align-items:center; padding:8px 10px; border:1px solid #e0e0e0; border-radius:4px; margin-bottom:6px; background:#fafafa;">
      <span style="font-weight:600; min-width:90px;" [title]="'Totaal beschikbaar: ' + (((timeslot?.minutes || 0) / 60).toFixed(2)) + 'u'">
        <input
          type="number"
          min="0"
          step="0.25"
          [ngModel]="getSesAllocatedHoursForTimeslot(timeslot)"
          (ngModelChange)="onSesAllocatedHoursChanged(timeslot, $event)"
          style="width:80px; padding:4px 6px; border:1px solid #ccc; border-radius:4px; font-weight:600;">
        u
      </span>
      <span>
        <strong *ngIf="getInvoiceProjects().length > 1">{{ timeslot?.project?.title }} — </strong>{{ getDescriptionForTimeslot(timeslot) }}
      </span>
    </div>
  </div>

  <!-- Timeslot-driven invoice lines: visible in 'By Time' mode -->
  <div *ngIf="invoiceMode==='time'">
    <div class="alert alert-danger" style="margin-top: 8px; margin-bottom: 8px;"
         *ngIf="project?.timesheetRequired && (selectedTimeslots?.length || 0) === 0">
      Tijdregistratie is verplicht. Selecteer minstens één timesheetregel om te kunnen factureren.
    </div>
    <p class="invoiceLines" style="margin-top: 8px; margin-bottom: 12px; font-weight: 600; font-size: 14px;">Invoice lines:</p>
    <div class="alert alert-info" style="margin-top: -6px; margin-bottom: 10px;" *ngIf="project?.invoiceByDay">
      Gefactureerd per dag i.p.v. per uur ({{ getProjectHoursPerDay() | number: '1.0-2' }}u/dag).
    </div>
  <div class="indent" *ngIf="checkIfAllInvoiceLinesHaveBeenBilled()" style="color: orange; font-weight: bold; margin-bottom: 10px;">
    ⚠️ Warning: All timeslots have already been billed!
  </div>
  <div *ngFor="let timeslot of timeslots">
    <p class="indent invoiceLine" [style.opacity]="timeslot.billed ? 0.6 : 1" style="display: flex; align-items: center; gap: 12px; margin: 12px 0; padding: 12px; border: 1px solid #e0e0e0; border-radius: 4px; background-color: #fafafa;">
      <input type="checkbox" [checked]="isTimeslotSelected(timeslot)" (change)="toggleTimeslotSelection($event.target.checked, timeslot)" style="width: 18px; height: 18px; cursor: pointer;">
      <input 
        type="text"
        [ngModel]="getDescriptionForTimeslot(timeslot)"
        (ngModelChange)="timeslot._editedDescription = $event"
        (blur)="onDescriptionBlur(timeslot)"
        [disabled]="!isTimeslotSelected(timeslot)"
        style="min-width: 300px; padding: 6px; font-size: 13px; border: 1px solid #ccc; border-radius: 3px; font-weight: 500;">
      <input 
        class="smallLength" 
        type="number" 
        [ngModel]="calculateWorkedHoursForTimeslot(timeslot) | number: '1.2-2'" 
        (ngModelChange)="timeslot._editedHours = $event"
        [disabled]="!isTimeslotSelected(timeslot)"
        style="width: 70px; padding: 8px; font-size: 13px; border: 1px solid #ccc; border-radius: 3px;">
      <span style="font-weight: 500;">×</span>
      <input 
        class="smallLength" 
        type="number" 
        [ngModel]="getPricePerHourForTimeslot(timeslot) | number: '1.2-2'" 
        (ngModelChange)="timeslot._editedRate = $event"
        (blur)="onPriceBlur(timeslot)"
        [disabled]="!selectedTimeslots.includes(timeslot)"
        style="width: 80px; padding: 8px; font-size: 13px; border: 1px solid #ccc; border-radius: 3px;"
        step="0.01">
      <span style="font-weight: 500;">=</span>
      <span style="font-weight: bold; min-width: 100px; text-align: right;">€{{ calculateEditablePriceForTimeslot(timeslot) | number: '1.2-2' }}</span>
      <span *ngIf="timeslot.billed" style="color: green; font-weight: bold; margin-left: auto;">✓ Already billed</span>
    </p>
    <div class="indent" *ngIf="project?.invoiceByDay && selectedTimeslots.includes(timeslot)" style="margin-top: -8px; margin-bottom: 8px; color: #555; font-size: 12px;">
      {{ calculateWorkedHoursForTimeslot(timeslot) | number: '1.2-2' }} dagen gefactureerd aan € {{ getPricePerHourForTimeslot(timeslot) | number: '1.2-2' }} / dag
    </div>
  </div>

    <div style="margin-top: 16px; display: flex; align-items: center; gap: 12px;">
      <input type="checkbox" [(ngModel)]="addProjectManagementFee" style="width: 18px; height: 18px; cursor: pointer;">
      <span style="min-width: 150px; font-weight: 500;">projectmanagement - </span>
      <input type="number" [(ngModel)]="projectManagementPercentage" min="0" max="100" style="width: 60px; padding: 4px; font-size: 14px; border: 1px solid #ccc; border-radius: 4px;">%
      <span style="width: 70px; text-align: center; font-weight: 500;">1</span>
      <span style="font-weight: 500;">×</span>
      <span style="width: 80px; text-align: right; font-weight: 500;">€{{ calculateProjectManagementFeeBeforeVat() | number: '1.2-2' }}</span>
      <span style="font-weight: 500;">=</span>
      <span style="font-weight: bold; min-width: 100px; text-align: right;">€{{ calculateProjectManagementFeeWithVat() | number: '1.2-2' }}</span>
    </div>
    <div style="margin-top: 12px; display: flex; align-items: center; gap: 12px; background: #f7f7f7; border-radius: 4px; padding: 12px; font-weight: bold;">
      <span style="min-width: 150px;">Totaal</span>
      <span style="font-weight: bold; min-width: 100px; text-align: right;">€{{ (calculateTotalBeforeVat() + calculateProjectManagementFeeBeforeVat()) | number: '1.2-2' }}</span>
    </div>

    <!-- Attachments Section -->
    <div style="border-top: 2px solid #ddd; margin-top: 16px; padding-top: 12px;">
    <p class="invoiceLines" style="margin-bottom: 8px; font-weight: 600; font-size: 14px;">Timesheet PDFs (geselecteerde periodes):</p>
    <div *ngIf="!hasAnyPdf()" style="color: #666; font-size: 12px;">Geen timesheet PDFs gevonden.</div>
    <div *ngIf="hasAnyPdf()">
      <div *ngFor="let pdf of getAllPdfEntries()" style="display: flex; align-items: center; gap: 12px; margin: 6px 0; padding: 10px; border: 1px solid #e0e0e0; border-radius: 4px; background-color: #f8fafc;">
        <label style="display:flex; align-items:center; gap:6px; font-size:12px; margin-right: 4px;">
          <input type="checkbox" [checked]="isAttachmentSelected(pdf.timeslotUuid)"
                 (change)="toggleAttachmentSelection($event.target.checked, findTimeslotByUuid(pdf.timeslotUuid))"
                 style="width: 16px; height: 16px; cursor: pointer;">
        </label>
        <i class="las la-file-pdf" style="font-size: 20px; color: #d32f2f;"></i>
        <span style="flex: 1; font-size: 13px;">{{ pdf.fileName }} <span *ngIf="pdf.monthLabel" style="color:#888">({{ pdf.monthLabel }})</span></span>
        <button type="button" (click)="previewAttachment(pdf.pdfUrl)" title="Preview PDF"
          style="padding: 4px 8px; font-size: 12px; background-color: #2196F3; color: white; border: none; border-radius: 3px; cursor: pointer;">
          Preview
        </button>
        <button type="button" (click)="runAttachmentValidation(findTimeslotByUuid(pdf.timeslotUuid))" title="Re-validate"
          [disabled]="isValidatingAttachment[pdf.timeslotUuid]"
          style="padding: 4px 8px; font-size: 12px; background-color: #455A64; color: white; border: none; border-radius: 3px; cursor: pointer;">
          Re-validate
        </button>
      </div>
      <!-- Validation progress indicator -->
      <div *ngIf="isAnyValidationInProgress()" class="alert alert-info" style="margin-top: 8px; display:flex; align-items:center; gap:8px;">
        <span class="ai-spinner" aria-hidden="true"></span>
        <span>Validating timesheet…</span>
      </div>
      <!-- Per-file check status summary (suggestive, non-blocking) -->
      <div class="alert alert-info" style="margin-top: 8px;">
        <div style="font-weight:600; margin-bottom:6px;">Controle-status per bijlage:</div>
        <div *ngFor="let item of getValidationChecks()" style="margin-bottom:6px;">
          <div style="display:flex; flex-wrap: wrap; gap:8px;">
            <span *ngFor="let st of item.statuses"
                  [style.color]="st.value==='ok' ? '#2e7d32' : (st.value==='fout' ? '#c62828' : '#555')"
                  style="font-size:12px; padding:4px 8px; border:1px solid #ddd; border-radius:12px; background:#fafafa;">
              {{ st.label }}: {{ st.display }}
            </span>
          </div>
        </div>
        <div style="font-size:12px; color:#555; margin-top:4px;">Tip: Deze controles zijn suggestief en blokkeren het maken van de factuur niet.</div>
      </div>
      <div class="alert alert-danger" style="margin-top: 8px;"
           *ngIf="project?.timesheetRequired && (selectedAttachments?.length || 0) === 0">
        Tijdregistratie is verplicht. Selecteer minstens één timesheet PDF bijlage.
      </div>
    </div>
    </div>
  </div>

</div>

<!-- Success overlay after invoice creation -->
<div *ngIf="finalizedInvoicePdfUrl" style="border-top: 3px solid #4caf50; margin-top: 16px; padding: 20px 16px; background: #f1f8e9; border-radius: 0 0 6px 6px;">
  <div style="display:flex; align-items:center; gap:12px; margin-bottom:12px;">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none"><path d="M9 12l2 2 4-4" stroke="#4caf50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="12" r="10" stroke="#4caf50" stroke-width="2"/></svg>
    <div>
      <div style="font-weight:700; font-size:15px; color:#2e7d32;">Factuur succesvol aangemaakt!</div>
      <div style="font-size:13px; color:#555;" *ngIf="finalizedInvoiceNumber">Factuurnummer: <strong>{{ finalizedInvoiceNumber }}</strong></div>
    </div>
  </div>
  <div style="display:flex; gap:10px; flex-wrap:wrap;">
    <a [href]="finalizedInvoicePdfUrl" target="_blank" style="display:inline-flex; align-items:center; gap:8px; padding:10px 18px; background:#d32f2f; color:#fff; border-radius:4px; text-decoration:none; font-weight:600; font-size:14px;">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M6 2h7l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 2v6h6" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
      Open PDF
    </a>
    <a *ngIf="finalizedInvoiceLink" [href]="finalizedInvoiceLink" target="_blank" style="display:inline-flex; align-items:center; gap:8px; padding:10px 18px; background:#1565c0; color:#fff; border-radius:4px; text-decoration:none; font-weight:600; font-size:14px;">
      Bekijk in Comanage
    </a>
  </div>
</div>

<mat-dialog-actions class="buttons">
  <!-- After invoice creation: show Close + Open PDF -->
  <ng-container *ngIf="finalizedInvoicePdfUrl; else preCreateActions">
    <button class="button m-r-1" mat-button (click)="closeDialog()">Sluiten</button>
    <a class="button m-r-1" mat-button [href]="finalizedInvoicePdfUrl" target="_blank" style="text-decoration:none;">Open PDF</a>
    <a *ngIf="finalizedInvoiceLink" class="button m-r-1" mat-button [href]="finalizedInvoiceLink" target="_blank" style="text-decoration:none;">Bekijk in Comanage</a>
  </ng-container>
  <ng-template #preCreateActions>
    <button class="button m-r-1" mat-button (click)="closeDialog()">Cancel</button>
    <button class="button m-r-1" mat-button (click)="sendInvoice()" [disabled]="isDisabled">Create Invoice</button>
    <small class="form-error" style="color:#d32f2f; margin-left: 8px;"
           *ngIf="!selectedComanageSupplierId">
      Selecteer een klant.
    </small>
    <small class="form-error" style="color:#d32f2f; margin-left: 8px;"
           *ngIf="project?.timesheetRequired && invoiceMode==='time' && (selectedTimeslots?.length || 0) === 0">
      Selecteer minstens één timeslot.
    </small>
    <small class="form-error" style="color:#d32f2f; margin-left: 8px;"
           *ngIf="project?.timesheetRequired && invoiceMode==='account' && !hasSelectedAccountLine()">
      Selecteer minstens één accountregel.
    </small>
    <small class="form-error" style="color:#d32f2f; margin-left: 8px;"
           *ngIf="invoiceMode==='ses' && (!selectedSesDoc || getSelectedSesAmount() <= 0 || isSelectedSesHoursMatch() === false)">
      Selecteer een geldige SES en zorg dat de uren overeenkomen.
    </small>
    <small class="form-error" style="color:#d32f2f; margin-left: 8px;"
           *ngIf="project?.timesheetRequired && invoiceMode==='time' && (selectedAttachments?.length || 0) === 0">
      Selecteer minstens één timesheet PDF bijlage.
    </small>
  </ng-template>
</mat-dialog-actions>
